export const FormFieldKeys = {
	COLLECTION_NAME: 'collectionName',
	PROJECTS: 'projects',
	FILTERS: 'filters',
} as const;
